export default "__VITE_ASSET__CHAEeCgJ__"